import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'

import getPhoenixUrlParams from '../../lib/get-phoenix-url-params'
import { usePaypalPayLaterDisclaimerOrderQuery } from '../../graphql'
import { getSharedConfig } from '../../get-config'

const PaypalPayLaterDisclaimer = () => {
  const location = useLocation()
  const { tld } = useSettingsContext()
  const { orderId } = getPhoenixUrlParams(location.search)
  const { data } = usePaypalPayLaterDisclaimerOrderQuery({ variables: { orderId: orderId as string } })

  if (!data || tld !== 'de') return null
  if (!data.order.priceTable.total?.value) return null

  const amount = data.order.priceTable.total.value / 100
  const paypalScript = `https://www.paypal.com/sdk/js?client-id=${
    getSharedConfig().PAYPAL_CLIENT_ID
  }&components=messages&currency=EUR`

  return (
    <>
      <Helmet>
        <script src={paypalScript} />
      </Helmet>
      <div
        data-pp-message
        data-pp-amount={amount}
        data-pp-countryCode={tld.toUpperCase()}
        data-pp-buyerCountry={tld.toUpperCase()}
        data-pp-currency="EUR"
        data-pp-style-layout="text"
        data-pp-style-logo-type="inline"
        data-pp-style-text-color="black"
        data-pp-style-text-size="14"
        style={{ paddingTop: '16px' }}
      ></div>
    </>
  )
}

export default PaypalPayLaterDisclaimer
